const API = "api/v1";

export default API;
